export default "__VITE_ASSET__DMND_ADn__"